module.exports = __webpack_public_path__ + "img/brume-hero_xl.b22110e.webp";